const UserTypeEnum = {
  USER_CONSUMER: 'C',
  USER_DEALER: 'D',
  USER_INTERNAL: 'I',
};

export default UserTypeEnum;
